import React, { useEffect } from 'react'
import { Breadcrumb, Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchCompanyIdInfo } from '../../../redux/action/company/company-id'
import MainLoading from '../../../utils/MainLoading'
import Wrapper from '../../homeWrapper/Wrapper'
import CompanyAboutus from './companyAboutus/CompanyAboutus'
import CompanyComment from './companyComment/CompanyComment'
import CompanyInfo from './companyInfo/CompanyInfo'
import CompanyMainInfo from './companyMainInfo/CompanyMainInfo'
import CompanyProducts from './companyProducts/CompanyProducts'

const CompanyId = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const loading = useSelector(state => state.company_info)
    const data = useSelector(state => state.company_id.company_info)
    const check = useSelector(state => state.company_id)

    useEffect(() => {
        dispatch(fetchCompanyIdInfo(props.match.params.id))
    }, [])

    if(check.loading) {
        return (
            <Wrapper>
                <MainLoading />
            </Wrapper>
        )
    } else {
        return (
            <Wrapper>
                {loading.loading ?
                    <MainLoading />
                :   
                    <>
                    {data.profile && 
                        <div className='company-wrapper'>
                            <Helmet>
                                <title>{data.profile.title && data.profile.title} - نمایشگاه مجازی</title>
                            </Helmet>
                            <Container>
                                <Breadcrumb className='saloon_breadcrumb mt-0 mb-2'>
                                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/saloons" }} >{t("dashboard_nav_saloons")}</Breadcrumb.Item>
                                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/saloon/${data.saloon && data.saloon.id}` }} >{data.saloon ? data.saloon.name : '...'}</Breadcrumb.Item>
                                    <Breadcrumb.Item active>{data.profile ? data.profile.title : '...'}</Breadcrumb.Item>
                                </Breadcrumb>
                            </Container>
                            <Container>
                                <CompanyMainInfo data={data} />
                                <CompanyAboutus data={data} />
                            </Container>
                            <CompanyProducts data={data.category_products} />
                            <CompanyInfo data={data} /> 
                                    
                            <Container>
                                <CompanyComment data={data} />
                            </Container>
                        </div>
                    }
                    </>
                }
            </Wrapper>
        )   
    }
}

export default CompanyId
